import { BadPressMatchRecord } from './../../../badpress-match.model';
import { Component, OnInit, Input, HostListener } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MdDialogRef } from '@angular/material';
import { URLSearchParams } from '@angular/http';

import { compareElements } from 'app/shared/validators/generic-validators';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';
import { unsavedFormCheck } from 'app/shared/validators/generic-validators';
import { BadPressService } from 'app/entities/monitoring/actual/badpress/bad-press.service';

@Component({
  templateUrl: './update-bad-press-match.component.html',
  providers: [BadPressService],
})

/**
 * Dialog component to update bad press information.
 */
export class UpdateBadPressMatchComponent implements OnInit {
  badPressMatchForm: FormGroup;
  argBadPressMatchDetailsData: string;
  argId: number;
  entityTypeId: number;
  argEntityType: string;

  constructor(private formBuilder: FormBuilder,
    public dialogRef: MdDialogRef<any>,
    private badPressMatchService: BadPressService,
    private snackBarService: SnackBarService,
    private trackingService: TrackingService) {
  }

  ngOnInit(): void {
    this.buildForm();
    this.updateTaskDetailsDataForm();
  }

  // @todo This function might get updated once REST is available.
  buildForm() {
    this.badPressMatchForm = this.formBuilder.group({
      //generalInfoText: [{ value: "" }],
    });
  }

  // Method to update task values and display in the dialog.
  updateTaskDetailsDataForm(): void {
    this.entityTypeId = this.argId;
    if (this.argBadPressMatchDetailsData) {
      this.badPressMatchForm.patchValue({
        //generalInfoText: this.argSanctionDetailsData,
      });
    }
  }

  // Method to submit the changes for Task Guide text.
  onSubmit({ value, valid }) {
    this.badPressMatchForm.disable();
    const badPressMatchModel = new BadPressMatchRecord();
    this.badPressMatchService.updateBadPressInfoDescription(badPressMatchModel, this.argEntityType)
      .subscribe(response => {
        if (response.flagResult) {
          this.dialogRef.close(badPressMatchModel);
        }
        this.trackingService
          .emitEvent(
          TrackingConstants.GENERAL_INFO_TEXT_UPDATE,
          TrackingConstants.PERFORM_GENERAL_INFO_TEXT_UPDATE,
          TrackingConstants.SUCCESS, 1);
        this.callSnackBarService(response);
      }, err => {
        this.trackingService
          .emitEvent(
          TrackingConstants.GENERAL_INFO_TEXT_UPDATE,
          TrackingConstants.PERFORM_GENERAL_INFO_TEXT_UPDATE,
          TrackingConstants.FAILURE, 0);
        this.callSnackBarService(err);
      }
      );
  }

  callSnackBarService(response: any) {
    this.snackBarService
      .showStatus(response,
      MessageService.GENERAL_INFO_TEXT_UPDATE_SUCCESS,
      MessageService.GENERAL_INFO_TEXT_UPDATE_FAILURE);
  }

  @HostListener('keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    unsavedFormCheck(event, this.dialogRef, this.badPressMatchForm);
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/monitoring/actual/badpress/badpressmatch/updatebadpressmatch/update-bad-press-match.component.ts